export const CONNECTION_ACTIVE_ROUTES = [
  'settings_inbox_list',
  'settings_inbox_show',
  'settings_inbox_new',
  'settings_inbox_finish',
  'settings_inboxes_page_channel',
  'settings_inboxes_add_agents',
];

export const INTEGRATION_ACTIVE_ROUTES = [
  'settings_applications',
  'settings_integrations_dashboard_apps',
  'settings_integrations_webhook',
  'settings_integrations_slack',
  'settings_integrations_linear',
  'settings_integrations_notion',
  'settings_integrations_shopify',
  'settings_integrations_google_calendar',
  'settings_integrations_banking',
  'settings_integrations_erp',
  'settings_applications_integration',
];

const SETTINGS_GROUPS = {
  automation: {
    name: 'Navigation Automation Tools',
    label: 'Ferramentas do atendimento',
    icon: 'i-hugeicons-flash',
    itemNames: ['Settings Macros', 'Settings Canned Responses'],
  },
  account: {
    name: 'Navigation Account And Team',
    label: 'Conta e equipe',
    icon: 'i-hugeicons-user-multiple',
    itemNames: [
      'Settings Account Settings',
      'Settings Agents',
      'Settings Teams',
      'Settings Custom Roles',
      'Settings Agent Assignment',
      'Agent Availability',
    ],
  },
  service: {
    name: 'Navigation Service Settings',
    label: 'Atendimento',
    icon: 'i-hugeicons-chatting-01',
    itemNames: [
      'Settings Labels',
      'Settings Custom Attributes',
      'Settings Sla',
    ],
  },
  security: {
    name: 'Navigation Security',
    label: 'Segurança e acesso',
    icon: 'i-hugeicons-security-check',
    itemNames: ['Settings Audit Logs', 'Settings Security'],
  },
};

const HOME_ONLY_ITEM_NAMES = ['Portals', 'Tour Talkvia'];

const MODULES = [
  {
    name: 'section-IXC',
    label: 'IXCsoft',
    icon: 'i-hugeicons-router',
    itemNames: ['IXC'],
    flattenItemNames: ['IXC'],
  },
  {
    name: 'section-Marketing',
    label: 'Agente de Marketing IA',
    icon: 'i-hugeicons-ai-paintbrush',
    itemNames: ['Agente de Marketing IA'],
    directItemName: 'Agente de Marketing IA',
  },
  {
    name: 'section-Talkvia Studio',
    label: 'Talkvia Studio',
    icon: 'i-hugeicons-scissor-01',
    itemNames: ['Talkvia Studio'],
    directItemName: 'Talkvia Studio',
  },
  {
    name: 'section-Lanchonete',
    label: 'Talkvia Food',
    icon: 'i-hugeicons-menu-restaurant',
    itemNames: ['Lanchonete'],
    directItemName: 'Lanchonete',
  },
  {
    name: 'section-Corban',
    label: 'Corban',
    icon: 'i-hugeicons-bank',
    itemNames: [
      'Pulso CLT',
      'Motores de crédito',
      'Simuladores manuais',
      'Consulta Lote CLT',
      'Consulta CLT',
      'Benefício 360',
      'Esteira de propostas',
    ],
  },
  {
    name: 'section-Operação',
    label: 'Operação',
    icon: 'i-hugeicons-briefcase-01',
    itemNames: [
      'Kanban',
      'Agenda',
      'Contratos',
      'Gestão de carteira',
      'Cadastrar cliente',
      'Calls',
      'Contacts',
      'Opt-in e opt-out',
      'Novidades',
    ],
  },
  {
    name: 'section-Campanhas e dados',
    label: 'Campanhas e dados',
    icon: 'i-hugeicons-megaphone-01',
    itemNames: [
      'Higienização',
      'SMS',
      'Campaigns',
      'Email Campaigns',
      'Captação de leads',
      'Funil visual',
      'WhatsApp Flows',
      'Catálogos do WhatsApp',
      'Templates da Meta',
    ],
    directSettingNames: ['Settings Interactive Messages'],
  },
  {
    name: 'section-Automação e IA',
    label: 'Automação e IA',
    icon: 'i-hugeicons-ai-magic',
    itemNames: ['Supervisão IA', 'Captain'],
    settingsGroups: ['automation'],
    // Atalhos e Respostas rápidas aparecem direto no módulo, sem agrupador.
    flattenSettingsGroups: ['automation'],
    directSettingNames: ['Settings Automation', 'Conversation Workflow'],
  },
  {
    name: 'section-Canais e integrações',
    label: 'Canais e integrações',
    icon: 'i-hugeicons-connect',
    itemNames: [
      'Visão geral',
      'Connections',
      'Assistente IA',
      'Biblioteca de IA',
      'Integrations',
    ],
  },
  {
    name: 'section-Logística',
    label: 'Logística',
    icon: 'i-hugeicons-route-02',
    itemNames: [
      'Estoque',
      'Rotas',
      'Contratos',
      'Fornecedores',
      'Contas a receber',
      'Contas a pagar',
      'Conciliação',
    ],
  },
  {
    name: 'section-Indicadores',
    label: 'Indicadores',
    icon: 'i-hugeicons-analytics-up',
    itemNames: ['Reports'],
    flattenItemNames: ['Reports'],
  },
  {
    name: 'section-Financeiro',
    label: 'Financeiro',
    icon: 'i-hugeicons-invoice-01',
    itemNames: ['Financeiro'],
    directItemName: 'Financeiro',
  },
  {
    name: 'section-Gestão',
    label: 'Ajustes',
    icon: 'i-hugeicons-settings-01',
    itemNames: [],
    settingsGroups: ['account', 'service', 'security'],
    flattenSettingsGroups: ['account'],
    directSettingNames: ['Settings API Docs'],
  },
  {
    name: 'section-Marketplace',
    label: 'Marketplace',
    icon: 'i-hugeicons-shopping-bag-01',
    itemNames: ['Marketplace', 'Indique e ganhe'],
  },
];

const REPORT_GROUPS = [
  [
    'Atendimento',
    'i-hugeicons-chatting-01',
    ['Report Conversation', 'Reports Inbox', 'Reports Label'],
  ],
  [
    'Equipe e produtividade',
    'i-hugeicons-user-multiple',
    ['Reports Agent', 'Reports Team', 'Reports Agent Pauses'],
  ],
  [
    'Qualidade e automação',
    'i-hugeicons-checkmark-badge-01',
    ['Reports CSAT', 'Reports SLA', 'Reports Bot'],
  ],
  [
    'Consumo e custos',
    'i-hugeicons-chart-column',
    ['Reports Meta Usage', 'Reports AI Usage', 'Reports IXC'],
  ],
];

export const organizeReportItems = items => {
  const byName = new Map(items.map(item => [item.name, item]));
  const groupedNames = new Set(REPORT_GROUPS.flatMap(([, , names]) => names));
  return [
    ...items.filter(item => !groupedNames.has(item.name)),
    ...REPORT_GROUPS.map(([label, icon, names]) => ({
      name: `Reports Group ${label}`,
      label,
      icon,
      children: names.map(name => byName.get(name)).filter(Boolean),
    })).filter(group => group.children.length),
  ];
};

const cloneItem = item => (item ? { ...item } : null);

export const matchesSidebarActiveRoute = (item, route) =>
  Boolean(
    item.activeOn?.includes(route.name) &&
      Object.entries(item.to?.params || {}).every(
        ([key, value]) => String(value) === String(route.params?.[key])
      )
  );

export const matchesSidebarChildPath = (child, routePath, resolvePath) => {
  if (!child.to) return false;

  const childPath = resolvePath(child.to);
  return (
    routePath === childPath ||
    (!child.activeOn?.length && routePath.startsWith(`${childPath}/`))
  );
};

/**
 * Reorganizes the desktop navigation modules shared by the vertical and
 * horizontal layouts, preserving routes and customization.
 */
export const organizeDesktopMenuSections = (sourceSections, options = {}) => {
  const sourceItems = (sourceSections || []).flatMap(section => section.items);
  const logisticsEnabled =
    options.logisticsEnabled ??
    sourceItems.some(item => ['Estoque', 'Rotas'].includes(item.name));
  const settings = sourceItems.find(item => item.name === 'Settings');
  const settingsItems = settings?.children || [];
  const topLevelByName = new Map(sourceItems.map(item => [item.name, item]));
  const settingByName = new Map(settingsItems.map(item => [item.name, item]));
  const assignedTopLevelNames = new Set(['Settings', ...HOME_ONLY_ITEM_NAMES]);
  const assignedSettingNames = new Set();

  const buildSettingsGroup = groupKey => {
    const definition = SETTINGS_GROUPS[groupKey];
    const children = definition.itemNames
      .map(name => settingByName.get(name))
      .filter(Boolean)
      .map(cloneItem);

    children.forEach(child => assignedSettingNames.add(child.name));
    if (!children.length) return null;

    return {
      name: definition.name,
      label: definition.label,
      icon: definition.icon,
      children,
    };
  };

  const modules = MODULES.map(module => {
    const items = module.itemNames.flatMap(name => {
      const item = topLevelByName.get(name);
      if (!item) return [];

      assignedTopLevelNames.add(item.name);
      if (module.flattenItemNames?.includes(name) && item.children?.length) {
        return name === 'Reports'
          ? organizeReportItems(item.children.map(cloneItem))
          : item.children.map(cloneItem);
      }

      return [cloneItem(item)];
    });

    const directItem = module.directItemName
      ? topLevelByName.get(module.directItemName)
      : null;

    (module.settingsGroups || []).forEach(groupKey => {
      const group = buildSettingsGroup(groupKey);
      if (!group) return;

      if (module.flattenSettingsGroups?.includes(groupKey)) {
        items.push(...group.children);
      } else {
        items.push(group);
      }
    });

    (module.directSettingNames || []).forEach(name => {
      const item = settingByName.get(name);
      if (!item) return;

      assignedSettingNames.add(item.name);
      items.push(cloneItem(item));
    });

    return {
      ...module,
      items:
        module.name === 'section-Logística' && !logisticsEnabled ? [] : items,
      ...(directItem
        ? {
            direct: true,
            to: directItem.to,
            activeOn: directItem.activeOn,
          }
        : {}),
    };
  });

  const management = modules.find(module => module.name === 'section-Gestão');
  const unclassifiedSettings = settingsItems
    .filter(item => !assignedSettingNames.has(item.name))
    .map(cloneItem);

  if (unclassifiedSettings.length) {
    management.items.push({
      name: 'Navigation Advanced Settings',
      label: 'Configurações avançadas',
      icon: 'i-hugeicons-settings-04',
      children: unclassifiedSettings,
    });
  }

  sourceItems
    .filter(item => !assignedTopLevelNames.has(item.name))
    .map(cloneItem)
    .forEach(item => management.items.push(item));

  return modules
    .map(
      ({
        itemNames,
        settingsGroups,
        flattenSettingsGroups,
        flattenItemNames,
        directItemName,
        directSettingNames,
        ...module
      }) => module
    )
    .filter(module => module.items.length);
};
